export const THEMES_CHANGE_THEME = 'THEMES_CHANGE_THEME';
export const THEMES_LOAD_THEME_SETTINGS = 'THEMES_LOAD_THEME_SETTINGS';
export const THEMES_ADJUST_THEME_SETTINGS = 'THEMES_ADJUST_THEME_SETTINGS';
export const THEMES_TOGGLE_SYSTEM_THEME_SWITCH = 'THEMES_TOGGLE_SYSTEM_THEME_SWITCH';
